module.exports = __webpack_public_path__ + "img/Ambassadorship@3x.019d5da7.png";